module.exports = __webpack_public_path__ + "media/images/monitor-0e1d64dd96106e877ea8059220adcdac.png";